import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import Styled from 'styled-components';
import Row from 'components/Row';
import { useActions } from 'helpers/useActions';
import {
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select
} from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import { PrimaryButton } from 'components/Buttons/PrimaryButton';
import { addForumPostAction, updateForumPostAction } from '../actions';

const initForum = {
  message: '',
  commentCount: 0,
  upVotes: [],
  tag: null,
  popularity: 0
};

function NewForumPost({ edit, post = initForum, onClose }) {
  let [forumInfo, setForumInfo] = React.useState(post);
  let [selected, setSelected] = React.useState(0);
  const addForumPost = useActions(addForumPostAction);
  const updateForumPost = useActions(updateForumPostAction);
  const categories = useSelector(state => state.forumState.subjects);

  useEffect(() => {
    if (edit) {
      let s = categories.findIndex(val => val === post.tag);
      if (s !== -1) {
        setSelected(s);
      }
      setForumInfo({ ...post });
    }
  }, [edit, post, categories]);

  function handleChange(e) {
    setForumInfo({ ...forumInfo, message: e.target.value });
  }

  function sendForumPost(e) {
    e.preventDefault();
    forumInfo.subject = categories[selected].name;
    if (edit) {
      updateForumPost(forumInfo);
      setForumInfo(initForum);
      setSelected(0);
      onClose();
    } else {
      addForumPost(forumInfo);
      setForumInfo(initForum);
      setSelected(0);
    }
  }

  function onSelectedChange(e) {
    setSelected(parseInt(e.target.value));
  }

  const validate = e => {
    if (!forumInfo.message) {
      alert('Please fill up all fields');
    } else {
      sendForumPost(e);
    }
  };
  return (
    <>
      <Container>
        <Row>
          <TextField
            id="outlined-dense"
            label="Write to ask on forum..."
            multiline
            rows={3}
            margin="dense"
            variant="outlined"
            value={forumInfo.message}
            style={{ marginTop: 0, width: '100%' }}
            onInput={handleChange}
          />
        </Row>
        <FormControl variant="outlined">
          <InputLabel htmlFor="catergory">Please select a category</InputLabel>
          <Select
            value={selected}
            style={{ display: 'flex', marginBottom: '8px' }}
            input={<OutlinedInput name="age" id="category" labelWidth={190} />}
            onChange={onSelectedChange}
          >
            {categories.map((cat, i) => (
              <MenuItem value={i} key={cat.name}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Row justify="flex-end">
          <PrimaryButton onClick={e => validate(e)}>
            {!edit ? 'Post' : 'Update'}
          </PrimaryButton>
        </Row>
      </Container>
    </>
  );
}

const Container = Styled.div`
  display: flex;
  flex-direction: column;
`;

export default withTheme(NewForumPost);
